import React from "react";
import * as T from "prop-types";

import { Field, Inputs } from "2g-form";

import { DATA } from "b2b/api/paths";
import { ZadostiStav } from "b2b/renderers/ciselnik/";

import useMessages from "./i18n/useMessages";

export function ACZadostiStav({ ...props }) {
  const { zadostiStavLabel, zadostiStavPlaceholder } = useMessages();
  return (
    <Field
      component={Inputs.AutoComplete}
      url={DATA.dataZadostiStavy()}
      rendererSelected={ZadostiStav}
      rendererOption={ZadostiStav}
      loadOnce
      staticKey={["stavCs", "stavEn"]}
      minChars={0}
      label={zadostiStavLabel()}
      placeholder={zadostiStavPlaceholder()}
      descriptionRenderer={ZadostiStav}
      {...props}
    />
  );
}

ACZadostiStav.propTypes = {
  multiple: T.bool
};

export default React.memo(ACZadostiStav);
